import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
var basePath = 'faxDocumentCategories';
var templatesAndCategoriesPath = "".concat(basePath, "/templatesAndCategories");
var crud = createCrud(basePath);

/* Default queries */
export var useFaxDocumentCategoryCount = crud.makeCount();
export var useFaxDocumentCategoryById = crud.makeFindById();
export var useFaxDocumentCategoryByIds = crud.makeFindByIds();
export var useFaxDocumentCategoryMany = crud.makeFindMany();
export var useFaxDocumentCategoryOne = crud.makeFindOne();
export var useFaxDocumentCategoryPagination = crud.makePagination();

/* Default mutations */
export var useFaxDocumentCategoryCreateOne = crud.makeCreateOne();
export var useFaxDocumentCategoryUpdateOne = crud.makeUpdateOne();
export var useFaxDocumentCategoryPatchOne = crud.makePatchOne();
export var useFaxDocumentCategoryRemoveById = crud.makeRemoveById();

/* Custom queries */

/* Custom mutations */
export function useFaxDocumentCategoryEnable(options) {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.post("/v2/".concat(basePath, "/enable"), data);
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutationFn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return useMutation([templatesAndCategoriesPath], mutationFn, options);
}
export function useFaxDocumentCategoryDisable(options) {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosClient.patch("/v2/".concat(basePath, "/disable"), data);
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function mutationFn(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return useMutation([templatesAndCategoriesPath], mutationFn, options);
}
export function useFaxDocumentCategoryPatch(options) {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
      var _ref3$_id, _id, autoApprove, fieldsToExtract, fileNameFormat, assignee, keywords, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref3$_id = _ref3._id, _id = _ref3$_id === void 0 ? '' : _ref3$_id, autoApprove = _ref3.autoApprove, fieldsToExtract = _ref3.fieldsToExtract, fileNameFormat = _ref3.fileNameFormat, assignee = _ref3.assignee, keywords = _ref3.keywords;
            _context3.next = 3;
            return axiosClient.patch("/v2/".concat(basePath, "/").concat(_id), {
              autoApprove: autoApprove,
              fieldsToExtract: fieldsToExtract,
              fileNameFormat: fileNameFormat,
              assignee: assignee,
              keywords: keywords
            });
          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function mutationFn(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  return useMutation([templatesAndCategoriesPath], mutationFn, options);
}